module.exports = __webpack_public_path__ + "static/media/frameworks.60824c35.png";